import React from 'react';

import routes from '../routes/routes';

const Body = () => <React.Fragment>{routes}</React.Fragment>;

export default Body;
